import { createApp } from 'vue'
import GelirVergisi from './GelirVergisi.vue'
import './assets/global.css'

createApp(GelirVergisi).mount('#gelir-vergisi')
